import type WidgetType from 'const/widget-type-constant';

export enum RequestContendTypeEnum {
  X_WWW_FORM_URLENCODED = `application/x-www-form-urlencoded`,
  APPLICATION_JSON = `application/json`
}

export enum OtherWidgetType {
  ID = 'ID',
  FUNCTION = 'FUNCTION'
}

export interface OtherWidget {
  type: OtherWidgetType;
  label?: string;
  enabled: boolean;
  id?: string;
  function?: string;
}
export enum MenuType {
  LINK = 'LINK',
  FUNCTION = 'FUNCTION',
  JSON = 'JSON'
}
export interface MenuOptionData {
  type: MenuType;
  label: string;
  link?: string;
  function?: string;
  icon: string;
  hideMinimizedIcon: boolean;
}
export interface MenuOption {
  enabled: boolean;
  data: MenuOptionData;
}
export enum SurveyTypes {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  RATING = 'RATING',
  CHECKBOX = 'CHECKBOX',
  TOUCHSELECT = 'TOUCHSELECT',
  STARRATE = 'STARRATE'
}

export interface Elements {
  type: SurveyTypes;
  name: string;
  title: string;
  rows?: number;
  row?: number;
  number?: number;
  questions?: string[];
  numberOfStars?: number;
}
export interface Basket {
  mergeToCart?: boolean;
  buyNow?: boolean;
}
export interface CategoryWidgetOption {
  category: string;
  widgetOption: WidgetOption;
}
export interface CategorySplashScreen {
  category: string;
  splashScreen: SplashScreen;
}
export interface Menu {
  offline?: MenuOption[];
  online?: MenuOption[];
}
export interface CategoryMenu {
  category: string;
  menu: Menu;
}
export interface Connection {
  productIdExtractCode?: string;
  productTypeExtractCode?: string;
}
export interface StoreDetails {
  subscription: string;
  id: string;
  storeType: string;
  schedulingOption: SchedulingOption;
  callSettings: CallSettings;
  callQueuing: boolean;
  callRejoin: boolean;
  currency: Currency;
  theme: Theme;
  settings: Settings;
  workingHours: WorkingHours;
  otherWidgets: OtherWidget[];
  offlineMenu: MenuOption[];
  onlineMenu: MenuOption[];
  connection: Connection;
  inventory: Inventory;
  productConf: ProductConf;
  widgetOption: WidgetOption;
  splashScreen: SplashScreen;
  permissionScreen: PermissionScreen;
  mergeToCart: MergeToCart;
  name: string;
  baseUrl: string;
  customerSurvey?: { backgroundImageURI?: string; elements: Elements[] };
  conciergeUrl: string;
  basket: Basket;
  categoryWidgetOptions: CategoryWidgetOption[];
  categorySplashScreens: CategorySplashScreen[];
  categoryMenus: CategoryMenu[];
  currencyConversionRate: number;
  customerSetting?: CustomerSetting;
}

export interface SchedulingOption {
  enabled: boolean;
  type: 'APPOINTEDD' | 'CALENDLY' | 'QUDINI' | 'CAL';
}

export interface CallSettings {
  audio: boolean;
  chat: boolean;
  screenShare: boolean;
  video: boolean;
}

export interface Currency {
  symbol: string;
  value: string;
  vat: number;
  multiCurrency: boolean;
}

export interface Theme {
  backgroundColor: string;
  textColor?: string;
  font: string;
  color: string;
  logo?: string;
  videoUrl?: string;
}

export interface Settings {
  color: string;
  ctaWidget: string;
  conciergeUrl: string;
  position: string;
  ctaWidgetColor: string;
}
export enum DayName {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export enum ButtonShape {
  SQUARE = 'SQUARE',
  DEFAULT = 'DEFAULT'
}

export enum Position {
  RIGHT = 'RIGHT',
  LEFT = 'LEFT'
}

export interface DayTypeDto {
  open: boolean;
  open24hours: boolean;
  name: DayName;
  openTime: string;
  closeTime: string;
}
export interface WorkingHours {
  alwaysOpen: boolean;
  timeZone?: string;
  days?: DayTypeDto[];
}

export interface Inventory {
  enabled: boolean;
}

export interface ProductConf {
  defaultProductImage: string;
  heroProductUrl: string;
}

export interface WidgetOption {
  color: string;
  type: WidgetType;
  widgetType: {
    desktop: Exclude<WidgetType, 'STRIP'>;
    mobile: WidgetType;
  };
  widgetPosition: {
    mobile: Position;
    desktop: Position;
  };
  position: Position;
  allowChatOnlyCall: boolean;
  allowVoiceOnlyCall: boolean;
  buttonShape: ButtonShape;
  texts: Texts;
  callWindowType: CallWindowType;
  enabled: boolean;
  avatarImg?: string;
  collapsed?: boolean;
  collapsedOnMobile?: boolean;
  videoUrl?: string;
}

export interface Texts {
  welcomeText: string;
  startCallText: string;
  bookAppointmentText: string;
  offlineWelcomeText: string;
  voiceOnlyText: string;
  chatOnlyText: string;
  callText: string;
}
export enum SplashScreenType {
  START_VIDEO = 'START_VIDEO',
  AUDIO_ONLY = 'AUDIO_ONLY',
  CHAT_ONLY = 'CHAT_ONLY',
  APPOINTMENT = 'APPOINTMENT',
  LINK = 'LINK'
}
export enum CallWindowType {
  WINDOW = 'WINDOW',
  MODEL = 'MODEL'
}
export interface SplashScreenWidget {
  icon: string;
  title: string;
  description: string;
  buttonText: string;
  event: SplashScreenType;
  link?: string;
}
export interface SplashScreen {
  widgets: SplashScreenWidget[];
  enabled: boolean;
}

export interface PermissionScreen {
  helperText: HelperText;
  content: Content;
  buttons: Buttons;
}

export interface HelperText {
  label: string;
  link: string;
}

export interface Content {
  titleText: string;
  videoLink: string;
}

export interface Buttons {
  audioOnlyText: string;
  videoAndAudioText: string;
  buttonShape: ButtonShape;
  isFlipped: boolean;
}

export interface MergeToCart {
  path?: string;
  requestContendType?: RequestContendTypeEnum;
  mapperCode: string;
  isClientSideCall?: boolean;
  clientSideMethod?: string;
  cartUrl?: string;
  mergeOneByOne?: boolean;
}

export interface CustomerSetting {
  getCustomerIdMapper?: string;
}
